import * as React from 'react';
import { Route } from 'react-router-dom';
import { authenticationService } from '../../services/authentication';
import { AppcuesData } from 'fs-api-client';
import Webportal from '../Webportal';
import { createDefaultApi } from '../../utils/createApi';
import * as constants from '../../utils/constants';
import { errorHandler } from '../../services/errorHandler';
import { EventHandler } from '../hocs/EventHandler';
import * as Amplitude from '@amplitude/analytics-browser';

let experimentalSettingsEnabled: string[];

class PrivateRoute extends React.Component<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            experimentalSettingsEnabled
        };
    }

    componentDidMount() {
        EventHandler.init(authenticationService.getLastKnownUserId());

        if (experimentalSettingsEnabled) { return; }
        if (!authenticationService.getWasAuthenticated()) { return; }
        if (constants.experimentalSettingsEnabled) {
            this.setExperimentalSettingsEnabled(constants.experimentalSettingsEnabled);
        } else {
            createDefaultApi()
                .then(async (defaultApi) => {
                    return defaultApi.getSettings();
                })
                .then((settings) => {
                    this.setExperimentalSettingsEnabled(settings.body);
                })
                .catch((error) => {
                    errorHandler(error);
                });
        }
    }

    componentWillUnmount() {
        EventHandler.reset();
    }

    render() {
        this.identifyUserInThirdPartyServices();

        const render = (props: any) => {
            const features = this.getExperimentalSettingsEnabled();
            const Component: any = this.props.component;
            const webportalComponent = <Component experimentalSettingsEnabled={features} {...props} {...this.props} />;

            return (
                <React.Fragment>
                    <Webportal experimentalSettingsEnabled={features}>
                        {webportalComponent}
                    </Webportal>
                </React.Fragment>
            );
        };

        import('src/webportal/theme/css/cms.css');

        return (
            <Route exact={this.props.exact} render={render}/>
        );
    }

    private getExperimentalSettingsEnabled(): string[] {
        return this.state.experimentalSettingsEnabled || [];
    }

    private setExperimentalSettingsEnabled(features: string[]): void {
        experimentalSettingsEnabled = features;
        this.setState({
            experimentalSettingsEnabled: features
        });
    }

    private async identifyUserInThirdPartyServices() {
        const defaultApi = await createDefaultApi();
        const appcuesData = (await defaultApi.getAppcuesData()).body as AppcuesData;

        try {
            Amplitude.setUserId(appcuesData.id);
        } catch (error) {
            console.error(error);
        }

        if (!(window as any).Appcues) {
            return;
        }

        (window as any).Appcues.identify(appcuesData.id, {
            createdAt: appcuesData.createdAt,
            isTrial: appcuesData.isTrial,
            isSuspended: appcuesData.isSuspended,
            isCreditCardEntered: appcuesData.isCreditCardEntered,
            isAlternativePaymentEntered: appcuesData.isAlternativePaymentEntered,
            isBillingAddressEntered: appcuesData.isBillingAddressEntered,
        });
    }
}

export default PrivateRoute;



// WEBPACK FOOTER //
// ./src/webportal/components/root/PrivateRoute.tsx